/**
 * Generated by orval v8.20.0 🍺
 * Do not edit manually.
 * Smart Sash Admin API
 * RESTful API for Smart Sash device management, user authentication, and system administration
 * OpenAPI spec version: 0.13.0.0
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  DeleteApiPortalMeFilesFoldersIdParams,
  GetApiPortalMeFilesParams,
  PortalBulkDeleteDto,
  PortalBulkMoveDto,
  PortalCreateFolderRequest,
  PortalDownloadTicketDto,
  PortalFileCountsDto,
  PortalFileFolderDto,
  PortalFileFolderListDto,
  PortalFileListDto,
  PortalFileListItemDto,
  PortalFileMoveRequest,
  PortalFileOriginsDto,
  PortalFileSelectionRequest,
  PortalFileStorageDto,
  PortalMoveFolderRequest,
  PortalRenameFolderRequest,
  PostApiPortalMeFilesBody,
  ProblemDetails
} from '../../models';

import { customInstance } from '../../../http/customInstance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getApiPortalMeFiles = (
    params?: GetApiPortalMeFilesParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PortalFileListDto>(
      {url: `/api/portal/me/files`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetApiPortalMeFilesInfiniteQueryKey = (params?: GetApiPortalMeFilesParams,) => {
    return [
    'infinite', `/api/portal/me/files`, ...(params ? [params] : [])
    ] as const;
    }

export const getGetApiPortalMeFilesQueryKey = (params?: GetApiPortalMeFilesParams,) => {
    return [
    `/api/portal/me/files`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiPortalMeFilesInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getApiPortalMeFiles>>>, TError = PortalFileListDto | ProblemDetails>(params?: GetApiPortalMeFilesParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiPortalMeFiles>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiPortalMeFilesInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiPortalMeFiles>>> = ({ signal }) => getApiPortalMeFiles(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiPortalMeFiles>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiPortalMeFilesInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getApiPortalMeFiles>>>
export type GetApiPortalMeFilesInfiniteQueryError = PortalFileListDto | ProblemDetails


export function useGetApiPortalMeFilesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiPortalMeFiles>>>, TError = PortalFileListDto | ProblemDetails>(
 params: undefined |  GetApiPortalMeFilesParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiPortalMeFiles>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiPortalMeFiles>>,
          TError,
          Awaited<ReturnType<typeof getApiPortalMeFiles>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiPortalMeFilesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiPortalMeFiles>>>, TError = PortalFileListDto | ProblemDetails>(
 params?: GetApiPortalMeFilesParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiPortalMeFiles>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiPortalMeFiles>>,
          TError,
          Awaited<ReturnType<typeof getApiPortalMeFiles>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiPortalMeFilesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiPortalMeFiles>>>, TError = PortalFileListDto | ProblemDetails>(
 params?: GetApiPortalMeFilesParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiPortalMeFiles>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiPortalMeFilesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiPortalMeFiles>>>, TError = PortalFileListDto | ProblemDetails>(
 params?: GetApiPortalMeFilesParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiPortalMeFiles>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiPortalMeFilesInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetApiPortalMeFilesQueryOptions = <TData = Awaited<ReturnType<typeof getApiPortalMeFiles>>, TError = PortalFileListDto | ProblemDetails>(params?: GetApiPortalMeFilesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPortalMeFiles>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiPortalMeFilesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiPortalMeFiles>>> = ({ signal }) => getApiPortalMeFiles(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiPortalMeFiles>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiPortalMeFilesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiPortalMeFiles>>>
export type GetApiPortalMeFilesQueryError = PortalFileListDto | ProblemDetails


export function useGetApiPortalMeFiles<TData = Awaited<ReturnType<typeof getApiPortalMeFiles>>, TError = PortalFileListDto | ProblemDetails>(
 params: undefined |  GetApiPortalMeFilesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPortalMeFiles>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiPortalMeFiles>>,
          TError,
          Awaited<ReturnType<typeof getApiPortalMeFiles>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiPortalMeFiles<TData = Awaited<ReturnType<typeof getApiPortalMeFiles>>, TError = PortalFileListDto | ProblemDetails>(
 params?: GetApiPortalMeFilesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPortalMeFiles>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiPortalMeFiles>>,
          TError,
          Awaited<ReturnType<typeof getApiPortalMeFiles>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiPortalMeFiles<TData = Awaited<ReturnType<typeof getApiPortalMeFiles>>, TError = PortalFileListDto | ProblemDetails>(
 params?: GetApiPortalMeFilesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPortalMeFiles>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiPortalMeFiles<TData = Awaited<ReturnType<typeof getApiPortalMeFiles>>, TError = PortalFileListDto | ProblemDetails>(
 params?: GetApiPortalMeFilesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPortalMeFiles>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiPortalMeFilesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const postApiPortalMeFiles = (
    postApiPortalMeFilesBody?: PostApiPortalMeFilesBody,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {

      const formData = new FormData();
if(postApiPortalMeFilesBody?.file !== undefined) {
 formData.append(`file`, postApiPortalMeFilesBody.file);
 }
if(postApiPortalMeFilesBody?.destination !== undefined) {
 formData.append(`destination`, postApiPortalMeFilesBody.destination);
 }
if(postApiPortalMeFilesBody?.folderId !== undefined) {
 formData.append(`folderId`, postApiPortalMeFilesBody.folderId);
 }

      return customInstance<PortalFileListItemDto>(
      {url: `/api/portal/me/files`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      options);
    }




export const getPostApiPortalMeFilesMutationOptions = <TError = PortalFileListItemDto | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiPortalMeFiles>>, TError,{data?: PostApiPortalMeFilesBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiPortalMeFiles>>, TError,{data?: PostApiPortalMeFilesBody}, TContext> => {

const mutationKey = ['postApiPortalMeFiles'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiPortalMeFiles>>, {data?: PostApiPortalMeFilesBody}> = (props) => {
          const {data} = props ?? {};

          return  postApiPortalMeFiles(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiPortalMeFilesMutationResult = NonNullable<Awaited<ReturnType<typeof postApiPortalMeFiles>>>
    export type PostApiPortalMeFilesMutationBody = PostApiPortalMeFilesBody | undefined
    export type PostApiPortalMeFilesMutationError = PortalFileListItemDto | ProblemDetails

    export const usePostApiPortalMeFiles = <TError = PortalFileListItemDto | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiPortalMeFiles>>, TError,{data?: PostApiPortalMeFilesBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiPortalMeFiles>>,
        TError,
        {data?: PostApiPortalMeFilesBody},
        TContext
      > => {
      return useMutation(getPostApiPortalMeFilesMutationOptions(options), queryClient);
    }
    export const getApiPortalMeFilesOrigins = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PortalFileOriginsDto>(
      {url: `/api/portal/me/files/origins`, method: 'GET', signal
    },
      options);
    }




export const getGetApiPortalMeFilesOriginsInfiniteQueryKey = () => {
    return [
    'infinite', `/api/portal/me/files/origins`
    ] as const;
    }

export const getGetApiPortalMeFilesOriginsQueryKey = () => {
    return [
    `/api/portal/me/files/origins`
    ] as const;
    }


export const getGetApiPortalMeFilesOriginsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getApiPortalMeFilesOrigins>>>, TError = ProblemDetails>( options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiPortalMeFilesOrigins>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiPortalMeFilesOriginsInfiniteQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiPortalMeFilesOrigins>>> = ({ signal }) => getApiPortalMeFilesOrigins(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiPortalMeFilesOrigins>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiPortalMeFilesOriginsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getApiPortalMeFilesOrigins>>>
export type GetApiPortalMeFilesOriginsInfiniteQueryError = ProblemDetails


export function useGetApiPortalMeFilesOriginsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiPortalMeFilesOrigins>>>, TError = ProblemDetails>(
  options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiPortalMeFilesOrigins>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiPortalMeFilesOrigins>>,
          TError,
          Awaited<ReturnType<typeof getApiPortalMeFilesOrigins>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiPortalMeFilesOriginsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiPortalMeFilesOrigins>>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiPortalMeFilesOrigins>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiPortalMeFilesOrigins>>,
          TError,
          Awaited<ReturnType<typeof getApiPortalMeFilesOrigins>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiPortalMeFilesOriginsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiPortalMeFilesOrigins>>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiPortalMeFilesOrigins>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiPortalMeFilesOriginsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiPortalMeFilesOrigins>>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiPortalMeFilesOrigins>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiPortalMeFilesOriginsInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetApiPortalMeFilesOriginsQueryOptions = <TData = Awaited<ReturnType<typeof getApiPortalMeFilesOrigins>>, TError = ProblemDetails>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPortalMeFilesOrigins>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiPortalMeFilesOriginsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiPortalMeFilesOrigins>>> = ({ signal }) => getApiPortalMeFilesOrigins(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiPortalMeFilesOrigins>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiPortalMeFilesOriginsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiPortalMeFilesOrigins>>>
export type GetApiPortalMeFilesOriginsQueryError = ProblemDetails


export function useGetApiPortalMeFilesOrigins<TData = Awaited<ReturnType<typeof getApiPortalMeFilesOrigins>>, TError = ProblemDetails>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPortalMeFilesOrigins>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiPortalMeFilesOrigins>>,
          TError,
          Awaited<ReturnType<typeof getApiPortalMeFilesOrigins>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiPortalMeFilesOrigins<TData = Awaited<ReturnType<typeof getApiPortalMeFilesOrigins>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPortalMeFilesOrigins>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiPortalMeFilesOrigins>>,
          TError,
          Awaited<ReturnType<typeof getApiPortalMeFilesOrigins>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiPortalMeFilesOrigins<TData = Awaited<ReturnType<typeof getApiPortalMeFilesOrigins>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPortalMeFilesOrigins>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiPortalMeFilesOrigins<TData = Awaited<ReturnType<typeof getApiPortalMeFilesOrigins>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPortalMeFilesOrigins>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiPortalMeFilesOriginsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiPortalMeFilesStorage = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PortalFileStorageDto>(
      {url: `/api/portal/me/files/storage`, method: 'GET', signal
    },
      options);
    }




export const getGetApiPortalMeFilesStorageInfiniteQueryKey = () => {
    return [
    'infinite', `/api/portal/me/files/storage`
    ] as const;
    }

export const getGetApiPortalMeFilesStorageQueryKey = () => {
    return [
    `/api/portal/me/files/storage`
    ] as const;
    }


export const getGetApiPortalMeFilesStorageInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getApiPortalMeFilesStorage>>>, TError = ProblemDetails>( options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiPortalMeFilesStorage>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiPortalMeFilesStorageInfiniteQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiPortalMeFilesStorage>>> = ({ signal }) => getApiPortalMeFilesStorage(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiPortalMeFilesStorage>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiPortalMeFilesStorageInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getApiPortalMeFilesStorage>>>
export type GetApiPortalMeFilesStorageInfiniteQueryError = ProblemDetails


export function useGetApiPortalMeFilesStorageInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiPortalMeFilesStorage>>>, TError = ProblemDetails>(
  options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiPortalMeFilesStorage>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiPortalMeFilesStorage>>,
          TError,
          Awaited<ReturnType<typeof getApiPortalMeFilesStorage>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiPortalMeFilesStorageInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiPortalMeFilesStorage>>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiPortalMeFilesStorage>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiPortalMeFilesStorage>>,
          TError,
          Awaited<ReturnType<typeof getApiPortalMeFilesStorage>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiPortalMeFilesStorageInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiPortalMeFilesStorage>>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiPortalMeFilesStorage>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiPortalMeFilesStorageInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiPortalMeFilesStorage>>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiPortalMeFilesStorage>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiPortalMeFilesStorageInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetApiPortalMeFilesStorageQueryOptions = <TData = Awaited<ReturnType<typeof getApiPortalMeFilesStorage>>, TError = ProblemDetails>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPortalMeFilesStorage>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiPortalMeFilesStorageQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiPortalMeFilesStorage>>> = ({ signal }) => getApiPortalMeFilesStorage(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiPortalMeFilesStorage>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiPortalMeFilesStorageQueryResult = NonNullable<Awaited<ReturnType<typeof getApiPortalMeFilesStorage>>>
export type GetApiPortalMeFilesStorageQueryError = ProblemDetails


export function useGetApiPortalMeFilesStorage<TData = Awaited<ReturnType<typeof getApiPortalMeFilesStorage>>, TError = ProblemDetails>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPortalMeFilesStorage>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiPortalMeFilesStorage>>,
          TError,
          Awaited<ReturnType<typeof getApiPortalMeFilesStorage>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiPortalMeFilesStorage<TData = Awaited<ReturnType<typeof getApiPortalMeFilesStorage>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPortalMeFilesStorage>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiPortalMeFilesStorage>>,
          TError,
          Awaited<ReturnType<typeof getApiPortalMeFilesStorage>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiPortalMeFilesStorage<TData = Awaited<ReturnType<typeof getApiPortalMeFilesStorage>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPortalMeFilesStorage>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiPortalMeFilesStorage<TData = Awaited<ReturnType<typeof getApiPortalMeFilesStorage>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPortalMeFilesStorage>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiPortalMeFilesStorageQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiPortalMeFilesFolders = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PortalFileFolderListDto>(
      {url: `/api/portal/me/files/folders`, method: 'GET', signal
    },
      options);
    }




export const getGetApiPortalMeFilesFoldersInfiniteQueryKey = () => {
    return [
    'infinite', `/api/portal/me/files/folders`
    ] as const;
    }

export const getGetApiPortalMeFilesFoldersQueryKey = () => {
    return [
    `/api/portal/me/files/folders`
    ] as const;
    }


export const getGetApiPortalMeFilesFoldersInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getApiPortalMeFilesFolders>>>, TError = ProblemDetails>( options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiPortalMeFilesFolders>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiPortalMeFilesFoldersInfiniteQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiPortalMeFilesFolders>>> = ({ signal }) => getApiPortalMeFilesFolders(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiPortalMeFilesFolders>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiPortalMeFilesFoldersInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getApiPortalMeFilesFolders>>>
export type GetApiPortalMeFilesFoldersInfiniteQueryError = ProblemDetails


export function useGetApiPortalMeFilesFoldersInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiPortalMeFilesFolders>>>, TError = ProblemDetails>(
  options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiPortalMeFilesFolders>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiPortalMeFilesFolders>>,
          TError,
          Awaited<ReturnType<typeof getApiPortalMeFilesFolders>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiPortalMeFilesFoldersInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiPortalMeFilesFolders>>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiPortalMeFilesFolders>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiPortalMeFilesFolders>>,
          TError,
          Awaited<ReturnType<typeof getApiPortalMeFilesFolders>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiPortalMeFilesFoldersInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiPortalMeFilesFolders>>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiPortalMeFilesFolders>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiPortalMeFilesFoldersInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiPortalMeFilesFolders>>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiPortalMeFilesFolders>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiPortalMeFilesFoldersInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetApiPortalMeFilesFoldersQueryOptions = <TData = Awaited<ReturnType<typeof getApiPortalMeFilesFolders>>, TError = ProblemDetails>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPortalMeFilesFolders>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiPortalMeFilesFoldersQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiPortalMeFilesFolders>>> = ({ signal }) => getApiPortalMeFilesFolders(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiPortalMeFilesFolders>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiPortalMeFilesFoldersQueryResult = NonNullable<Awaited<ReturnType<typeof getApiPortalMeFilesFolders>>>
export type GetApiPortalMeFilesFoldersQueryError = ProblemDetails


export function useGetApiPortalMeFilesFolders<TData = Awaited<ReturnType<typeof getApiPortalMeFilesFolders>>, TError = ProblemDetails>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPortalMeFilesFolders>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiPortalMeFilesFolders>>,
          TError,
          Awaited<ReturnType<typeof getApiPortalMeFilesFolders>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiPortalMeFilesFolders<TData = Awaited<ReturnType<typeof getApiPortalMeFilesFolders>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPortalMeFilesFolders>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiPortalMeFilesFolders>>,
          TError,
          Awaited<ReturnType<typeof getApiPortalMeFilesFolders>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiPortalMeFilesFolders<TData = Awaited<ReturnType<typeof getApiPortalMeFilesFolders>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPortalMeFilesFolders>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiPortalMeFilesFolders<TData = Awaited<ReturnType<typeof getApiPortalMeFilesFolders>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPortalMeFilesFolders>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiPortalMeFilesFoldersQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const postApiPortalMeFilesFolders = (
    portalCreateFolderRequest?: PortalCreateFolderRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PortalFileFolderDto>(
      {url: `/api/portal/me/files/folders`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: portalCreateFolderRequest, signal
    },
      options);
    }




export const getPostApiPortalMeFilesFoldersMutationOptions = <TError = PortalFileFolderDto | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiPortalMeFilesFolders>>, TError,{data?: PortalCreateFolderRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiPortalMeFilesFolders>>, TError,{data?: PortalCreateFolderRequest}, TContext> => {

const mutationKey = ['postApiPortalMeFilesFolders'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiPortalMeFilesFolders>>, {data?: PortalCreateFolderRequest}> = (props) => {
          const {data} = props ?? {};

          return  postApiPortalMeFilesFolders(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiPortalMeFilesFoldersMutationResult = NonNullable<Awaited<ReturnType<typeof postApiPortalMeFilesFolders>>>
    export type PostApiPortalMeFilesFoldersMutationBody = PortalCreateFolderRequest | undefined
    export type PostApiPortalMeFilesFoldersMutationError = PortalFileFolderDto | ProblemDetails

    export const usePostApiPortalMeFilesFolders = <TError = PortalFileFolderDto | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiPortalMeFilesFolders>>, TError,{data?: PortalCreateFolderRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiPortalMeFilesFolders>>,
        TError,
        {data?: PortalCreateFolderRequest},
        TContext
      > => {
      return useMutation(getPostApiPortalMeFilesFoldersMutationOptions(options), queryClient);
    }
    export const getApiPortalMeFilesCounts = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PortalFileCountsDto>(
      {url: `/api/portal/me/files/counts`, method: 'GET', signal
    },
      options);
    }




export const getGetApiPortalMeFilesCountsInfiniteQueryKey = () => {
    return [
    'infinite', `/api/portal/me/files/counts`
    ] as const;
    }

export const getGetApiPortalMeFilesCountsQueryKey = () => {
    return [
    `/api/portal/me/files/counts`
    ] as const;
    }


export const getGetApiPortalMeFilesCountsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getApiPortalMeFilesCounts>>>, TError = PortalFileCountsDto | ProblemDetails>( options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiPortalMeFilesCounts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiPortalMeFilesCountsInfiniteQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiPortalMeFilesCounts>>> = ({ signal }) => getApiPortalMeFilesCounts(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiPortalMeFilesCounts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiPortalMeFilesCountsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getApiPortalMeFilesCounts>>>
export type GetApiPortalMeFilesCountsInfiniteQueryError = PortalFileCountsDto | ProblemDetails


export function useGetApiPortalMeFilesCountsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiPortalMeFilesCounts>>>, TError = PortalFileCountsDto | ProblemDetails>(
  options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiPortalMeFilesCounts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiPortalMeFilesCounts>>,
          TError,
          Awaited<ReturnType<typeof getApiPortalMeFilesCounts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiPortalMeFilesCountsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiPortalMeFilesCounts>>>, TError = PortalFileCountsDto | ProblemDetails>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiPortalMeFilesCounts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiPortalMeFilesCounts>>,
          TError,
          Awaited<ReturnType<typeof getApiPortalMeFilesCounts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiPortalMeFilesCountsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiPortalMeFilesCounts>>>, TError = PortalFileCountsDto | ProblemDetails>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiPortalMeFilesCounts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiPortalMeFilesCountsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiPortalMeFilesCounts>>>, TError = PortalFileCountsDto | ProblemDetails>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiPortalMeFilesCounts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiPortalMeFilesCountsInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetApiPortalMeFilesCountsQueryOptions = <TData = Awaited<ReturnType<typeof getApiPortalMeFilesCounts>>, TError = PortalFileCountsDto | ProblemDetails>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPortalMeFilesCounts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiPortalMeFilesCountsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiPortalMeFilesCounts>>> = ({ signal }) => getApiPortalMeFilesCounts(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiPortalMeFilesCounts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiPortalMeFilesCountsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiPortalMeFilesCounts>>>
export type GetApiPortalMeFilesCountsQueryError = PortalFileCountsDto | ProblemDetails


export function useGetApiPortalMeFilesCounts<TData = Awaited<ReturnType<typeof getApiPortalMeFilesCounts>>, TError = PortalFileCountsDto | ProblemDetails>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPortalMeFilesCounts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiPortalMeFilesCounts>>,
          TError,
          Awaited<ReturnType<typeof getApiPortalMeFilesCounts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiPortalMeFilesCounts<TData = Awaited<ReturnType<typeof getApiPortalMeFilesCounts>>, TError = PortalFileCountsDto | ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPortalMeFilesCounts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiPortalMeFilesCounts>>,
          TError,
          Awaited<ReturnType<typeof getApiPortalMeFilesCounts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiPortalMeFilesCounts<TData = Awaited<ReturnType<typeof getApiPortalMeFilesCounts>>, TError = PortalFileCountsDto | ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPortalMeFilesCounts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiPortalMeFilesCounts<TData = Awaited<ReturnType<typeof getApiPortalMeFilesCounts>>, TError = PortalFileCountsDto | ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPortalMeFilesCounts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiPortalMeFilesCountsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const patchApiPortalMeFilesFoldersId = (
    id: string,
    portalRenameFolderRequest?: PortalRenameFolderRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PortalFileFolderDto>(
      {url: `/api/portal/me/files/folders/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: portalRenameFolderRequest, signal
    },
      options);
    }




export const getPatchApiPortalMeFilesFoldersIdMutationOptions = <TError = PortalFileFolderDto | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiPortalMeFilesFoldersId>>, TError,{id: string;data?: PortalRenameFolderRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof patchApiPortalMeFilesFoldersId>>, TError,{id: string;data?: PortalRenameFolderRequest}, TContext> => {

const mutationKey = ['patchApiPortalMeFilesFoldersId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchApiPortalMeFilesFoldersId>>, {id: string;data?: PortalRenameFolderRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  patchApiPortalMeFilesFoldersId(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchApiPortalMeFilesFoldersIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchApiPortalMeFilesFoldersId>>>
    export type PatchApiPortalMeFilesFoldersIdMutationBody = PortalRenameFolderRequest | undefined
    export type PatchApiPortalMeFilesFoldersIdMutationError = PortalFileFolderDto | ProblemDetails

    export const usePatchApiPortalMeFilesFoldersId = <TError = PortalFileFolderDto | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiPortalMeFilesFoldersId>>, TError,{id: string;data?: PortalRenameFolderRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchApiPortalMeFilesFoldersId>>,
        TError,
        {id: string;data?: PortalRenameFolderRequest},
        TContext
      > => {
      return useMutation(getPatchApiPortalMeFilesFoldersIdMutationOptions(options), queryClient);
    }
    export const deleteApiPortalMeFilesFoldersId = (
    id: string,
    params?: DeleteApiPortalMeFilesFoldersIdParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PortalBulkDeleteDto | void>(
      {url: `/api/portal/me/files/folders/${id}`, method: 'DELETE',
        params, signal
    },
      options);
    }




export const getDeleteApiPortalMeFilesFoldersIdMutationOptions = <TError = PortalBulkDeleteDto | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiPortalMeFilesFoldersId>>, TError,{id: string;params?: DeleteApiPortalMeFilesFoldersIdParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiPortalMeFilesFoldersId>>, TError,{id: string;params?: DeleteApiPortalMeFilesFoldersIdParams}, TContext> => {

const mutationKey = ['deleteApiPortalMeFilesFoldersId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiPortalMeFilesFoldersId>>, {id: string;params?: DeleteApiPortalMeFilesFoldersIdParams}> = (props) => {
          const {id,params} = props ?? {};

          return  deleteApiPortalMeFilesFoldersId(id,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiPortalMeFilesFoldersIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiPortalMeFilesFoldersId>>>

    export type DeleteApiPortalMeFilesFoldersIdMutationError = PortalBulkDeleteDto | ProblemDetails

    export const useDeleteApiPortalMeFilesFoldersId = <TError = PortalBulkDeleteDto | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiPortalMeFilesFoldersId>>, TError,{id: string;params?: DeleteApiPortalMeFilesFoldersIdParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiPortalMeFilesFoldersId>>,
        TError,
        {id: string;params?: DeleteApiPortalMeFilesFoldersIdParams},
        TContext
      > => {
      return useMutation(getDeleteApiPortalMeFilesFoldersIdMutationOptions(options), queryClient);
    }
    export const postApiPortalMeFilesFoldersIdMove = (
    id: string,
    portalMoveFolderRequest?: PortalMoveFolderRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PortalFileFolderDto>(
      {url: `/api/portal/me/files/folders/${id}/move`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: portalMoveFolderRequest, signal
    },
      options);
    }




export const getPostApiPortalMeFilesFoldersIdMoveMutationOptions = <TError = PortalFileFolderDto | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiPortalMeFilesFoldersIdMove>>, TError,{id: string;data?: PortalMoveFolderRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiPortalMeFilesFoldersIdMove>>, TError,{id: string;data?: PortalMoveFolderRequest}, TContext> => {

const mutationKey = ['postApiPortalMeFilesFoldersIdMove'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiPortalMeFilesFoldersIdMove>>, {id: string;data?: PortalMoveFolderRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  postApiPortalMeFilesFoldersIdMove(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiPortalMeFilesFoldersIdMoveMutationResult = NonNullable<Awaited<ReturnType<typeof postApiPortalMeFilesFoldersIdMove>>>
    export type PostApiPortalMeFilesFoldersIdMoveMutationBody = PortalMoveFolderRequest | undefined
    export type PostApiPortalMeFilesFoldersIdMoveMutationError = PortalFileFolderDto | ProblemDetails

    export const usePostApiPortalMeFilesFoldersIdMove = <TError = PortalFileFolderDto | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiPortalMeFilesFoldersIdMove>>, TError,{id: string;data?: PortalMoveFolderRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiPortalMeFilesFoldersIdMove>>,
        TError,
        {id: string;data?: PortalMoveFolderRequest},
        TContext
      > => {
      return useMutation(getPostApiPortalMeFilesFoldersIdMoveMutationOptions(options), queryClient);
    }
    export const postApiPortalMeFilesMove = (
    portalFileMoveRequest?: PortalFileMoveRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PortalBulkMoveDto>(
      {url: `/api/portal/me/files/move`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: portalFileMoveRequest, signal
    },
      options);
    }




export const getPostApiPortalMeFilesMoveMutationOptions = <TError = PortalBulkMoveDto | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiPortalMeFilesMove>>, TError,{data?: PortalFileMoveRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiPortalMeFilesMove>>, TError,{data?: PortalFileMoveRequest}, TContext> => {

const mutationKey = ['postApiPortalMeFilesMove'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiPortalMeFilesMove>>, {data?: PortalFileMoveRequest}> = (props) => {
          const {data} = props ?? {};

          return  postApiPortalMeFilesMove(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiPortalMeFilesMoveMutationResult = NonNullable<Awaited<ReturnType<typeof postApiPortalMeFilesMove>>>
    export type PostApiPortalMeFilesMoveMutationBody = PortalFileMoveRequest | undefined
    export type PostApiPortalMeFilesMoveMutationError = PortalBulkMoveDto | ProblemDetails

    export const usePostApiPortalMeFilesMove = <TError = PortalBulkMoveDto | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiPortalMeFilesMove>>, TError,{data?: PortalFileMoveRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiPortalMeFilesMove>>,
        TError,
        {data?: PortalFileMoveRequest},
        TContext
      > => {
      return useMutation(getPostApiPortalMeFilesMoveMutationOptions(options), queryClient);
    }
    export const getApiPortalMeFilesId = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PortalFileListItemDto>(
      {url: `/api/portal/me/files/${id}`, method: 'GET', signal
    },
      options);
    }




export const getGetApiPortalMeFilesIdInfiniteQueryKey = (id: string,) => {
    return [
    'infinite', `/api/portal/me/files/${id}`
    ] as const;
    }

export const getGetApiPortalMeFilesIdQueryKey = (id: string,) => {
    return [
    `/api/portal/me/files/${id}`
    ] as const;
    }


export const getGetApiPortalMeFilesIdInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getApiPortalMeFilesId>>>, TError = ProblemDetails | PortalFileListItemDto>(id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiPortalMeFilesId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiPortalMeFilesIdInfiniteQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiPortalMeFilesId>>> = ({ signal }) => getApiPortalMeFilesId(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiPortalMeFilesId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiPortalMeFilesIdInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getApiPortalMeFilesId>>>
export type GetApiPortalMeFilesIdInfiniteQueryError = ProblemDetails | PortalFileListItemDto


export function useGetApiPortalMeFilesIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiPortalMeFilesId>>>, TError = ProblemDetails | PortalFileListItemDto>(
 id: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiPortalMeFilesId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiPortalMeFilesId>>,
          TError,
          Awaited<ReturnType<typeof getApiPortalMeFilesId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiPortalMeFilesIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiPortalMeFilesId>>>, TError = ProblemDetails | PortalFileListItemDto>(
 id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiPortalMeFilesId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiPortalMeFilesId>>,
          TError,
          Awaited<ReturnType<typeof getApiPortalMeFilesId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiPortalMeFilesIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiPortalMeFilesId>>>, TError = ProblemDetails | PortalFileListItemDto>(
 id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiPortalMeFilesId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiPortalMeFilesIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiPortalMeFilesId>>>, TError = ProblemDetails | PortalFileListItemDto>(
 id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiPortalMeFilesId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiPortalMeFilesIdInfiniteQueryOptions(id,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetApiPortalMeFilesIdQueryOptions = <TData = Awaited<ReturnType<typeof getApiPortalMeFilesId>>, TError = ProblemDetails | PortalFileListItemDto>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPortalMeFilesId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiPortalMeFilesIdQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiPortalMeFilesId>>> = ({ signal }) => getApiPortalMeFilesId(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiPortalMeFilesId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiPortalMeFilesIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiPortalMeFilesId>>>
export type GetApiPortalMeFilesIdQueryError = ProblemDetails | PortalFileListItemDto


export function useGetApiPortalMeFilesId<TData = Awaited<ReturnType<typeof getApiPortalMeFilesId>>, TError = ProblemDetails | PortalFileListItemDto>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPortalMeFilesId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiPortalMeFilesId>>,
          TError,
          Awaited<ReturnType<typeof getApiPortalMeFilesId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiPortalMeFilesId<TData = Awaited<ReturnType<typeof getApiPortalMeFilesId>>, TError = ProblemDetails | PortalFileListItemDto>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPortalMeFilesId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiPortalMeFilesId>>,
          TError,
          Awaited<ReturnType<typeof getApiPortalMeFilesId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiPortalMeFilesId<TData = Awaited<ReturnType<typeof getApiPortalMeFilesId>>, TError = ProblemDetails | PortalFileListItemDto>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPortalMeFilesId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiPortalMeFilesId<TData = Awaited<ReturnType<typeof getApiPortalMeFilesId>>, TError = ProblemDetails | PortalFileListItemDto>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPortalMeFilesId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiPortalMeFilesIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const deleteApiPortalMeFilesId = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/api/portal/me/files/${id}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteApiPortalMeFilesIdMutationOptions = <TError = ProblemDetails | unknown | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiPortalMeFilesId>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiPortalMeFilesId>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteApiPortalMeFilesId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiPortalMeFilesId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteApiPortalMeFilesId(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiPortalMeFilesIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiPortalMeFilesId>>>

    export type DeleteApiPortalMeFilesIdMutationError = ProblemDetails | unknown | null

    export const useDeleteApiPortalMeFilesId = <TError = ProblemDetails | unknown | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiPortalMeFilesId>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiPortalMeFilesId>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDeleteApiPortalMeFilesIdMutationOptions(options), queryClient);
    }
    export const getApiPortalMeFilesIdDownload = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PortalDownloadTicketDto>(
      {url: `/api/portal/me/files/${id}/download`, method: 'GET', signal
    },
      options);
    }




export const getGetApiPortalMeFilesIdDownloadInfiniteQueryKey = (id: string,) => {
    return [
    'infinite', `/api/portal/me/files/${id}/download`
    ] as const;
    }

export const getGetApiPortalMeFilesIdDownloadQueryKey = (id: string,) => {
    return [
    `/api/portal/me/files/${id}/download`
    ] as const;
    }


export const getGetApiPortalMeFilesIdDownloadInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getApiPortalMeFilesIdDownload>>>, TError = ProblemDetails | PortalDownloadTicketDto>(id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiPortalMeFilesIdDownload>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiPortalMeFilesIdDownloadInfiniteQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiPortalMeFilesIdDownload>>> = ({ signal }) => getApiPortalMeFilesIdDownload(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiPortalMeFilesIdDownload>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiPortalMeFilesIdDownloadInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getApiPortalMeFilesIdDownload>>>
export type GetApiPortalMeFilesIdDownloadInfiniteQueryError = ProblemDetails | PortalDownloadTicketDto


export function useGetApiPortalMeFilesIdDownloadInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiPortalMeFilesIdDownload>>>, TError = ProblemDetails | PortalDownloadTicketDto>(
 id: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiPortalMeFilesIdDownload>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiPortalMeFilesIdDownload>>,
          TError,
          Awaited<ReturnType<typeof getApiPortalMeFilesIdDownload>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiPortalMeFilesIdDownloadInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiPortalMeFilesIdDownload>>>, TError = ProblemDetails | PortalDownloadTicketDto>(
 id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiPortalMeFilesIdDownload>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiPortalMeFilesIdDownload>>,
          TError,
          Awaited<ReturnType<typeof getApiPortalMeFilesIdDownload>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiPortalMeFilesIdDownloadInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiPortalMeFilesIdDownload>>>, TError = ProblemDetails | PortalDownloadTicketDto>(
 id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiPortalMeFilesIdDownload>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiPortalMeFilesIdDownloadInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiPortalMeFilesIdDownload>>>, TError = ProblemDetails | PortalDownloadTicketDto>(
 id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiPortalMeFilesIdDownload>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiPortalMeFilesIdDownloadInfiniteQueryOptions(id,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetApiPortalMeFilesIdDownloadQueryOptions = <TData = Awaited<ReturnType<typeof getApiPortalMeFilesIdDownload>>, TError = ProblemDetails | PortalDownloadTicketDto>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPortalMeFilesIdDownload>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiPortalMeFilesIdDownloadQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiPortalMeFilesIdDownload>>> = ({ signal }) => getApiPortalMeFilesIdDownload(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiPortalMeFilesIdDownload>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiPortalMeFilesIdDownloadQueryResult = NonNullable<Awaited<ReturnType<typeof getApiPortalMeFilesIdDownload>>>
export type GetApiPortalMeFilesIdDownloadQueryError = ProblemDetails | PortalDownloadTicketDto


export function useGetApiPortalMeFilesIdDownload<TData = Awaited<ReturnType<typeof getApiPortalMeFilesIdDownload>>, TError = ProblemDetails | PortalDownloadTicketDto>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPortalMeFilesIdDownload>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiPortalMeFilesIdDownload>>,
          TError,
          Awaited<ReturnType<typeof getApiPortalMeFilesIdDownload>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiPortalMeFilesIdDownload<TData = Awaited<ReturnType<typeof getApiPortalMeFilesIdDownload>>, TError = ProblemDetails | PortalDownloadTicketDto>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPortalMeFilesIdDownload>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiPortalMeFilesIdDownload>>,
          TError,
          Awaited<ReturnType<typeof getApiPortalMeFilesIdDownload>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiPortalMeFilesIdDownload<TData = Awaited<ReturnType<typeof getApiPortalMeFilesIdDownload>>, TError = ProblemDetails | PortalDownloadTicketDto>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPortalMeFilesIdDownload>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiPortalMeFilesIdDownload<TData = Awaited<ReturnType<typeof getApiPortalMeFilesIdDownload>>, TError = ProblemDetails | PortalDownloadTicketDto>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPortalMeFilesIdDownload>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiPortalMeFilesIdDownloadQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const postApiPortalMeFilesDownload = (
    portalFileSelectionRequest?: PortalFileSelectionRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PortalDownloadTicketDto>(
      {url: `/api/portal/me/files/download`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: portalFileSelectionRequest, signal
    },
      options);
    }




export const getPostApiPortalMeFilesDownloadMutationOptions = <TError = PortalDownloadTicketDto | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiPortalMeFilesDownload>>, TError,{data?: PortalFileSelectionRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiPortalMeFilesDownload>>, TError,{data?: PortalFileSelectionRequest}, TContext> => {

const mutationKey = ['postApiPortalMeFilesDownload'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiPortalMeFilesDownload>>, {data?: PortalFileSelectionRequest}> = (props) => {
          const {data} = props ?? {};

          return  postApiPortalMeFilesDownload(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiPortalMeFilesDownloadMutationResult = NonNullable<Awaited<ReturnType<typeof postApiPortalMeFilesDownload>>>
    export type PostApiPortalMeFilesDownloadMutationBody = PortalFileSelectionRequest | undefined
    export type PostApiPortalMeFilesDownloadMutationError = PortalDownloadTicketDto | ProblemDetails

    export const usePostApiPortalMeFilesDownload = <TError = PortalDownloadTicketDto | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiPortalMeFilesDownload>>, TError,{data?: PortalFileSelectionRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiPortalMeFilesDownload>>,
        TError,
        {data?: PortalFileSelectionRequest},
        TContext
      > => {
      return useMutation(getPostApiPortalMeFilesDownloadMutationOptions(options), queryClient);
    }
    export const getApiPortalFilesDownloadToken = (
    token: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/api/portal/files/download/${token}`, method: 'GET', signal
    },
      options);
    }




export const getGetApiPortalFilesDownloadTokenInfiniteQueryKey = (token: string,) => {
    return [
    'infinite', `/api/portal/files/download/${token}`
    ] as const;
    }

export const getGetApiPortalFilesDownloadTokenQueryKey = (token: string,) => {
    return [
    `/api/portal/files/download/${token}`
    ] as const;
    }


export const getGetApiPortalFilesDownloadTokenInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getApiPortalFilesDownloadToken>>>, TError = ProblemDetails>(token: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiPortalFilesDownloadToken>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiPortalFilesDownloadTokenInfiniteQueryKey(token);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiPortalFilesDownloadToken>>> = ({ signal }) => getApiPortalFilesDownloadToken(token, requestOptions, signal);





   return  { queryKey, queryFn, enabled: token !== null && token !== undefined, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiPortalFilesDownloadToken>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiPortalFilesDownloadTokenInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getApiPortalFilesDownloadToken>>>
export type GetApiPortalFilesDownloadTokenInfiniteQueryError = ProblemDetails


export function useGetApiPortalFilesDownloadTokenInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiPortalFilesDownloadToken>>>, TError = ProblemDetails>(
 token: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiPortalFilesDownloadToken>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiPortalFilesDownloadToken>>,
          TError,
          Awaited<ReturnType<typeof getApiPortalFilesDownloadToken>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiPortalFilesDownloadTokenInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiPortalFilesDownloadToken>>>, TError = ProblemDetails>(
 token: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiPortalFilesDownloadToken>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiPortalFilesDownloadToken>>,
          TError,
          Awaited<ReturnType<typeof getApiPortalFilesDownloadToken>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiPortalFilesDownloadTokenInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiPortalFilesDownloadToken>>>, TError = ProblemDetails>(
 token: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiPortalFilesDownloadToken>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiPortalFilesDownloadTokenInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiPortalFilesDownloadToken>>>, TError = ProblemDetails>(
 token: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiPortalFilesDownloadToken>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiPortalFilesDownloadTokenInfiniteQueryOptions(token,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetApiPortalFilesDownloadTokenQueryOptions = <TData = Awaited<ReturnType<typeof getApiPortalFilesDownloadToken>>, TError = ProblemDetails>(token: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPortalFilesDownloadToken>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiPortalFilesDownloadTokenQueryKey(token);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiPortalFilesDownloadToken>>> = ({ signal }) => getApiPortalFilesDownloadToken(token, requestOptions, signal);





   return  { queryKey, queryFn, enabled: token !== null && token !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiPortalFilesDownloadToken>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiPortalFilesDownloadTokenQueryResult = NonNullable<Awaited<ReturnType<typeof getApiPortalFilesDownloadToken>>>
export type GetApiPortalFilesDownloadTokenQueryError = ProblemDetails


export function useGetApiPortalFilesDownloadToken<TData = Awaited<ReturnType<typeof getApiPortalFilesDownloadToken>>, TError = ProblemDetails>(
 token: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPortalFilesDownloadToken>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiPortalFilesDownloadToken>>,
          TError,
          Awaited<ReturnType<typeof getApiPortalFilesDownloadToken>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiPortalFilesDownloadToken<TData = Awaited<ReturnType<typeof getApiPortalFilesDownloadToken>>, TError = ProblemDetails>(
 token: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPortalFilesDownloadToken>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiPortalFilesDownloadToken>>,
          TError,
          Awaited<ReturnType<typeof getApiPortalFilesDownloadToken>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiPortalFilesDownloadToken<TData = Awaited<ReturnType<typeof getApiPortalFilesDownloadToken>>, TError = ProblemDetails>(
 token: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPortalFilesDownloadToken>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiPortalFilesDownloadToken<TData = Awaited<ReturnType<typeof getApiPortalFilesDownloadToken>>, TError = ProblemDetails>(
 token: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPortalFilesDownloadToken>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiPortalFilesDownloadTokenQueryOptions(token,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const postApiPortalMeFilesDelete = (
    portalFileSelectionRequest?: PortalFileSelectionRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PortalBulkDeleteDto>(
      {url: `/api/portal/me/files/delete`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: portalFileSelectionRequest, signal
    },
      options);
    }




export const getPostApiPortalMeFilesDeleteMutationOptions = <TError = PortalBulkDeleteDto | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiPortalMeFilesDelete>>, TError,{data?: PortalFileSelectionRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiPortalMeFilesDelete>>, TError,{data?: PortalFileSelectionRequest}, TContext> => {

const mutationKey = ['postApiPortalMeFilesDelete'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiPortalMeFilesDelete>>, {data?: PortalFileSelectionRequest}> = (props) => {
          const {data} = props ?? {};

          return  postApiPortalMeFilesDelete(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiPortalMeFilesDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof postApiPortalMeFilesDelete>>>
    export type PostApiPortalMeFilesDeleteMutationBody = PortalFileSelectionRequest | undefined
    export type PostApiPortalMeFilesDeleteMutationError = PortalBulkDeleteDto | ProblemDetails

    export const usePostApiPortalMeFilesDelete = <TError = PortalBulkDeleteDto | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiPortalMeFilesDelete>>, TError,{data?: PortalFileSelectionRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiPortalMeFilesDelete>>,
        TError,
        {data?: PortalFileSelectionRequest},
        TContext
      > => {
      return useMutation(getPostApiPortalMeFilesDeleteMutationOptions(options), queryClient);
    }
